import { DotNetValidationProblemDetails } from "../types";

export function createValidationProblemDetails() {
  return {
    errors: {}
  }
}

export function isValid(valProblems: DotNetValidationProblemDetails) {
  if (valProblems.errors) {
    for (let key in valProblems.errors) {
      if (valProblems.errors[key]!.length > 0) {
        return false;
      }
    }
  }
  return true;
}

export function returnIfInvalid(valProblems: DotNetValidationProblemDetails) {
  return isValid(valProblems) ? undefined : valProblems;
}

export function appendErrorTo(valProblems: DotNetValidationProblemDetails, key: string, msg: string) {
  if (valProblems.errors[key]) {
    valProblems.errors[key]?.push(msg);
  } else {
    valProblems.errors[key] = [msg];
  }
}

export function validateRequired(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  value?: string,
): boolean {
  if (!value || value.trimEnd().length === 0) {
    appendErrorTo(valProblems, key, `The ${label} field is required.`);
    return false;
  }
  return true;
}

export function validateSelectionRequired(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  value?: number,
): boolean {
  if (!value || value <= 0) {
    appendErrorTo(valProblems, key, `The ${label} field is required.`);
    return false;
  }
  return true;
}

export function validateNumberRequired(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  value?: number,
): boolean {
  if (value === undefined || value === null || isNaN(value)) {
    appendErrorTo(valProblems, key, `The ${label} field is required.`);
    return false;
  }
  return true;
}

export function validateMaxLength(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  maxLength: number,
  value?: string,
): boolean {
  if (value && value.trimEnd().length > maxLength) {
    appendErrorTo(valProblems, key, `The field ${label} must be a string with a maximum length of ${maxLength}.`);
    return false;
  }
  return true;
}

export function validateMaxLengthWitoutTrimEnd(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  maxLength: number,
  value?: string,
): boolean {
  if (value && value.length > maxLength) {
    appendErrorTo(valProblems, key, `The field ${label} must be a string with a maximum length of ${maxLength}.`);
    return false;
  }
  return true;
}

export function validateNoSpace(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  value?: string,
): boolean {
  if (value && value.trimEnd().indexOf(' ') >= 0) {
    appendErrorTo(valProblems, key, `The field ${label} must be a string without space.`);
    return false;
  }
  return true;
}

export function validateNoSpecialCharacters(
  valProblems: DotNetValidationProblemDetails,
  key: string,
  label: string,
  value?: string,
  allowUnderscoreAndHyphen?: boolean
): boolean {
  if (allowUnderscoreAndHyphen) {
    var format = /[`~!@#$%^&*()+=\[\]{};':"\\|,.<>\/?]+/;
    var msg = `The ${label} field cannot contain special characters, except hyphen "-" and underscore "_".`;
  } else {
    var format = /[`~!@#$%^&*_\-()+=\[\]{};':"\\|,.<>\/?]+/;
    var msg = `The ${label} field cannot contain special characters.`;
  }
  if (value && format.test(value.trimEnd())) {
    appendErrorTo(valProblems, key, msg);
    return false;
  }
  return true;
}
